import { render } from "./MosaicColumns.vue?vue&type=template&id=2110c407"
import script from "./MosaicColumns.vue?vue&type=script&lang=js"
export * from "./MosaicColumns.vue?vue&type=script&lang=js"

import "./MosaicColumns.vue?vue&type=style&index=0&id=2110c407&lang=scss"
script.render = render

export default script